import Vue from "vue";
import store from "../store";

Vue.filter("checkPermission", (value) => {
  let permissions = [];
  permissions = store.getters["rolePermissions/getPermissionsToLoginAccount"];
  return permissions.some((element) => element === value);
});
